var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SML_SIZE } from '../constants/common';
export var reactSelectStyles = function (size) {
    switch (size) {
        case SML_SIZE.M:
            return {
                control: function (base) { return (__assign(__assign({}, base), { height: 56, minHeight: 56 })); }
            };
        case SML_SIZE.S:
        default:
            return {
                control: function (base) { return (__assign(__assign({}, base), { height: 40, minHeight: 40 })); }
            };
    }
};
export var selectValueToReadableString = function (value) {
    if (Array.isArray(value)) {
        var string_1 = '';
        value.forEach(function (eachValue) {
            string_1 = string_1 + (string_1 ? ", ".concat(String(eachValue.label)) : String(eachValue.label));
        });
        return string_1;
    }
    return value === null || value === void 0 ? void 0 : value.label;
};
export var convertArrayToKeyObject = function (array, key) {
    if (key === void 0) { key = 'id'; }
    var object = {};
    array.forEach(function (each) {
        object[each[key]] = each;
    });
    return object;
};
export var mapLabelValue = function (option, labelIdentifier, keyIdentifier) {
    if (labelIdentifier === void 0) { labelIdentifier = 'label'; }
    if (keyIdentifier === void 0) { keyIdentifier = 'id'; }
    return option.map(function (each) { return ({
        label: each[labelIdentifier],
        value: each[keyIdentifier]
    }); });
};
export var scrollTo = function (height) {
    if (height === void 0) { height = 0; }
    window === null || window === void 0 ? void 0 : window.scrollTo({
        top: height,
        left: 100,
        behavior: 'smooth'
    });
};
/**
 * Merge any number of array of objects with count aggregation
 * @param filters array of array of filters
 * @returns merged array of filters
 */
export var mergeObjectArray = function (filters) {
    var mergedFilters = [];
    // Convert all filter arrays to object {title: filter}
    var objectMap = filters.map(function (eachFilter) { return convertArrayToKeyObject(eachFilter, 'id'); });
    // Extract all unique filter titles in a set
    var keys = new Set();
    objectMap.forEach(function (eachFilter) {
        var currentKeys = Object.keys(eachFilter);
        currentKeys.forEach(function (eachKey) { return keys.add(eachKey); });
    });
    // Loop for each id, find match in all the filter objects
    // and create a new filter object with all matched filter options appended
    // finally add the new filter to new filter array
    keys.forEach(function (eachKey) {
        var eachMergedFilter = null;
        objectMap.forEach(function (eachFilter) {
            var currentKeyValue = eachFilter[eachKey];
            if (currentKeyValue) {
                if (!eachMergedFilter) {
                    eachMergedFilter = __assign({}, currentKeyValue);
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    eachMergedFilter.count += currentKeyValue.count;
                }
            }
        });
        mergedFilters.push(eachMergedFilter);
    });
    return mergedFilters;
};
export var breakCamelCase = function (value) {
    return value.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
    });
};
export var breakSnakeCase = function (value) {
    return value.split('_').join(' ');
};
export var checkValueMatch = function (value, matchWith) {
    if (Array.isArray(matchWith)) {
        return matchWith.includes(value === null || value === void 0 ? void 0 : value.toString());
    }
    else {
        return (matchWith === null || matchWith === void 0 ? void 0 : matchWith.toString()) === (value === null || value === void 0 ? void 0 : value.toString());
    }
};
/**
 *
 * @param file File object to be uploaded from client
 * @returns Promise that resolves into base64 text
 */
export var getBase64 = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        var _a, _b;
                        if (reader) {
                            var encoded = ((_a = reader === null || reader === void 0 ? void 0 : reader.result) === null || _a === void 0 ? void 0 : _a.toString().replace(/^data:(.*,)?/, '')) || '';
                            if (encoded.length % 4 > 0) {
                                encoded += '='.repeat(4 - (encoded.length % 4));
                            }
                            resolve(((_b = reader.result) === null || _b === void 0 ? void 0 : _b.toString()) || '');
                        }
                    };
                    reader.onerror = function (error) {
                        reject(error);
                    };
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Convert snake case to readable words like HELLO_WORLD to Hello World
 * @param str capitalized snake case word
 * @returns string
 */
export var convertToReadable = function (str) {
    var words = str.split('_');
    var capitalizedWords = words.map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); });
    return capitalizedWords.join(' ');
};
export var convertObjectProperty = function (obj, targetValue, newValue) {
    var objCopy = __assign({}, obj);
    Object.keys(objCopy).forEach(function (key) {
        if (objCopy[key] === targetValue) {
            objCopy[key] = newValue;
        }
    });
    return objCopy;
};
/**
 * Converts any word like rAbbit to Rabbit
 * @param word any text word
 * @returns string
 */
export var convertToNormalCase = function (word) {
    // Convert the entire word to lowercase
    var lowerCaseWord = word.toLowerCase();
    // Capitalize the first letter and concatenate the rest of the word
    return lowerCaseWord.charAt(0).toUpperCase() + lowerCaseWord.slice(1);
};
/**
 * Merges two objects and returns a new object.
 * @param obj1 - The first object to merge.
 * @param obj2 - The second object to merge.
 * @returns A new object with merged properties.
 * @throws Error if obj1 and obj2 have different types.
 */
export var mergeObjects = function (obj1, obj2) {
    if (typeof obj1 !== typeof obj2) {
        throw new Error('Both objects must have the same type.');
    }
    if (typeof obj1 === 'object' && obj1 !== null && typeof obj2 === 'object' && obj2 !== null) {
        var mergedObj = {};
        for (var key in obj1) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj1.hasOwnProperty(key) && obj1[key] !== undefined) {
                mergedObj[key] = obj1[key];
            }
        }
        for (var key in obj2) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj2.hasOwnProperty(key) && obj2[key] !== undefined && mergedObj[key] === undefined) {
                mergedObj[key] = obj2[key];
            }
        }
        return mergedObj;
    }
    return obj1;
};
/**
 * Get color values for feedback rating based on the provided value.
 *
 * @param {number|null|undefined} value - The rating value (0-5) or null/undefined.
 * @returns {{fill: string, stroke: string}} An object containing fill and stroke color values.
 * @example
 * const color = getFeedbackRatingColor(4);
 * // Returns: { fill: '#91BB82', stroke: '#527C43' } (default color for value > 3)
 *
 * const color = getFeedbackRatingColor(2);
 * // Returns: { fill: '#CB6C6C', stroke: '#8B2C2C' } (color for low rating)
 *
 * const color = getFeedbackRatingColor(0);
 * // Returns: { fill: '', stroke: '' } (color for 0 rating)
 *
 * const color = getFeedbackRatingColor();
 * // Returns: { fill: '', stroke: '' } (color for undefined value)
 */
export var getFeedbackRatingColor = function (value) {
    if ([0, undefined, null].includes(value)) {
        return {
            fill: '#BDBDBD',
            stroke: '#BDBDBD'
        };
    }
    if (value && value <= 2) {
        return {
            fill: '#CB6C6C',
            stroke: '#8B2C2C'
        };
    }
    if (value && value === 3) {
        return {
            fill: '#EDB779',
            stroke: '#AD7739'
        };
    }
    return {
        fill: '#91BB82',
        stroke: '#527C43'
    };
};
//# sourceMappingURL=index.js.map